<script setup>
import { ref, computed, onMounted } from 'vue'
import { DxPieChart, DxSeries, DxLegend, DxLabel, DxConnector } from 'devextreme-vue/pie-chart'
import { getI18n } from '@/plugins/i18n'
import { planningApi } from '@/apis/planning.api'
import { usePortalStore } from '@/stores/portal.store'

const { t } = getI18n()
const portalStore = usePortalStore()

const result = ref(null)

onMounted(async () => {
  const res = await planningApi.getEquipmentRepairOnTimeAsync()
  result.value = res.data
})

const pieData = computed(() => {
  if (!result.value) return []
  const pct = result.value.percentage ?? 0
  return [
    { label: 'On Time', value: pct },
    { label: 'Late', value: 100 - pct },
  ]
})

const thresholdLabel = computed(() => {
  if (!result.value) return ''
  const days = result.value.threshold_days
  const opt = portalStore.getLocalizedDurationDays().find(o => o.value === days)
  const label = opt?.label ?? `${days}`
  return t('common.repairOnTimeInfo', { days: label })
})

const percentage = computed(() => result.value?.percentage ?? null)

const customizePoint = ({ argument }) => ({
  color: argument === 'On Time' ? '#1565C0' : '#E0E0E0',
})
</script>

<template>
  <div class="fit column items-center justify-center q-pa-sm">
    <div v-if="result === null" class="col flex flex-center">
      <q-spinner size="md" color="primary" />
    </div>
    <template v-else>
      <div class="relative-position" style="width: 160px; height: 160px;">
        <dx-pie-chart
          :data-source="pieData"
          type="doughnut"
          :inner-radius="0.65"
          :customize-point="customizePoint"
          style="width: 160px; height: 160px;"
        >
          <dx-series argument-field="label" value-field="value">
            <dx-label :visible="false">
              <dx-connector :visible="false" />
            </dx-label>
          </dx-series>
          <dx-legend :visible="false" />
        </dx-pie-chart>
        <div
          class="absolute-center text-center"
          style="pointer-events: none;"
        >
          <div v-if="percentage !== null" class="text-h5 text-weight-bold text-primary">
            {{ percentage }}%
          </div>
          <div v-else class="text-h5 text-grey-5">—</div>
        </div>
      </div>
      <div class="text-subtitle2 text-weight-medium q-mt-sm">{{ t('dashboard.onTimeRepairs') }}</div>
      <div class="text-caption text-grey-6 q-mt-xs text-center" style="font-style: italic; max-width: 220px">
        {{ thresholdLabel }}
      </div>
    </template>
  </div>
</template>
